import Vue from 'vue'
import VueRouter from 'vue-router'
import homeTable from '../components/homeTable.vue'
import indexTable from '../components/indexTable.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'indexTable',
    component: indexTable,
  },
  {
    path: '/homeTable',
    name: 'homeTable',
    component: homeTable,
  },
  
]

const router = new VueRouter({
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
